module.exports = __webpack_public_path__ + "static/assets/de0ed1175830a31deef8decc472de74c.svg";